import { createContext, useContext } from 'react';

const defaultValue = {
  logo: null,
  isMenuamDomain: false,
  name: '',
};

export const MenuAmDomainContext = createContext(defaultValue);

export const MenuAmDomainProvider = ({ children, value = defaultValue }) => (
  <MenuAmDomainContext.Provider value={value}>
    {children}
  </MenuAmDomainContext.Provider>
);

export const useMenuAmDomainContext = () => {
  const context = useContext(MenuAmDomainContext);
  return context ?? defaultValue;
};
